jQuery(function ($) {
    // regardless of the language or how the dialog got closed we show it only once
    let $newsletterModal = $('#newsletterModal');
    if (localStorage.getItem('newsletter-dialog') === null) {
        $newsletterModal.modal('show');
        $newsletterModal.on('hide.bs.modal', () => {
            localStorage.setItem('newsletter-dialog', 'shown');
        });

        $('div.not-interested a').on('click', () => {
            $('#newsletterModal').modal('hide');
        });
    }
});
